"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var bodyScroll = function bodyScroll(event) {
  event.preventDefault();
};

var setEventDom = function setEventDom(dom) {
  return dom ? document.querySelector(dom) : document.body;
};

var disableBodyScroll = function disableBodyScroll(dom) {
  setEventDom(dom).addEventListener('touchmove', bodyScroll, {
    passive: false
  }, false);
  setEventDom(dom).style.overflow = 'hidden';
  setEventDom(dom).style.height = '100%';
};

var openBodyScroll = function openBodyScroll(dom) {
  setEventDom(dom).removeEventListener('touchmove', bodyScroll, {
    passive: false
  }, false);
  setEventDom(dom).style.overflow = 'auto';
  setEventDom(dom).style.height = 'auto';
};

var _default = {
  disableBodyScroll: disableBodyScroll,
  openBodyScroll: openBodyScroll
};
exports["default"] = _default;